import React from 'react';
import { useIsFeatureEnabled } from '@innovyze/stylovyze';
import EsriPropertyPane, {
	Props as EsriPropertyPaneProps,
} from '@Map/esri/features/PropertyPane/PropertyPane';
import { PropertyPane as MapComponentsPropertyPane } from '@innovyze/map-components';

/**
 * Union of Esri and Mapbox PropertyPane props.
 * Accepts all props from either implementation; each renderer ignores
 * props it doesn't support.
 */
export type PropertyPaneProps = EsriPropertyPaneProps & {
	/** map-components only: route to an inspection detail page */
	viewInspection?: (...args: unknown[]) => void;
	/** map-components only: route to a task detail page */
	viewTask?: (...args: unknown[]) => void;
	/** map-components only: route to an event detail page */
	viewEvent?: (...args: unknown[]) => void;
};

/**
 * Feature-flag–driven PropertyPane wrapper.
 *
 * When `info360-platform-esri-map` is enabled the Esri implementation is
 * rendered; otherwise the legacy `@innovyze/map-components` version is used.
 */
const PropertyPane = (props: PropertyPaneProps): JSX.Element => {
	const isEsri = Boolean(useIsFeatureEnabled('info360-platform-esri-map'));

	if (isEsri) {
		return <EsriPropertyPane {...props} />;
	}

	return <MapComponentsPropertyPane {...props} />;
};

export default PropertyPane;
